if (!process.env.REACT_APP_AWS_S3_BUCKET_BLUEPRINT_LINK) {
  throw new Error(
    "AWS_S3_BUCKET_BLUEPRINT_LINK is not defined in environment variables"
  );
}

if (!process.env.REACT_APP_AWS_LAMBDA_URL) {
  throw new Error("AWS_LAMBDA_URL is not defined in environment variables");
}

export const AWS_CONFIG = {
  PDF_LINK: process.env.REACT_APP_AWS_S3_BUCKET_BLUEPRINT_LINK,
  Lambda_URL: process.env.REACT_APP_AWS_LAMBDA_URL,
};
